import { Injectable } from '@angular/core';
import { HttpClient, HttpBackend } from '@angular/common/http'; // IMPORTANTE: Importar HttpBackend
import { environment } from '../../../environments/environment';
import { first } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class VersionCheckService {
  private currentVersion = environment.appVersion;
  private http: HttpClient; // Creamos un cliente http privado

  // Inyectamos HttpBackend en lugar de HttpClient directamente
  constructor(private handler: HttpBackend) {
    // Al instanciar HttpClient con el handler, se salta TODOS los interceptores
    this.http = new HttpClient(handler);
  }

  public initVersionCheck() {
    // Agregamos timestamp para romper caché
    const url = `assets/version.json?t=${new Date().getTime()}`;

    this.http.get<any>(url)
      .pipe(first())
      .subscribe({
        next: (serverData) => {
          console.log(`Versión Local: ${this.currentVersion} | Versión Server: ${serverData.version}`);
          
          if (serverData.version !== this.currentVersion) {
            console.warn('¡Versión desactualizada! Recargando...');
            window.location.reload();
          }
        },
        error: (err) => {
          // Ahora verás el error REAL en consola (probablemente 404 Not Found),
          // pero tu app no mostrará modales de error al usuario.
          console.error('No se pudo verificar la versión (esto es seguro de ignorar):', err);
        }
      });
  }
}